<style scoped lang="scss">
.uk-card-primary {
  color: white;
  background-color: #0f7ae5;
  padding: 20px;
  font-size: 1.2em;
  border-radius: 6px;
  margin-left: 40px;
  margin-right: 40px;
}
</style>

<template>
  <div class="uk-grid" id="hardship-question">
    <div class="uk-width-1-1">
        <h3 class="uk-text-center">
          {{ __('landing.hardship_question_title') }}
        </h3>
    </div>
    <div class="uk-width-1-1 uk-margin-top">
        <h4 class="uk-text-center">
          {{ __('landing.hardship_question_qualify') }}
          <br/><br/>
          {{ __('landing.hardship_question_or') }}
          <br/><br/>
          {{ __('landing.hardship_question_experienced') }}
        </h4>
    </div>
    <div class="uk-width-1-1 uk-margin-top">
      <label for="due" class="uk-margin-large-left">
        <input type="radio" v-model="selectionValue" value="due" id="due" class="uk-radio"/>
        {{ __('landing.hardship_question_due') }}
      </label>
    </div>

    <div class="uk-width-1-1 uk-margin-top">
      <label for="during" class="uk-margin-large-left">
        <input type="radio" v-model="selectionValue" value="during" id="during" class="uk-radio"/>
        {{ __('landing.hardship_question_during') }}
      </label>
    </div>
    <div class="uk-width-1-1 uk-margin-top">
      <label for="due_benefits" class="uk-margin-large-left">
        <input type="radio" v-model="selectionValue" value="due_benefits" id="due_benefits" class="uk-radio"/>
        {{ __('landing.hardship_question_due_benefits') }}
      </label>
    </div>
    <div class="uk-width-1-1 uk-margin-top">
      <label for="none" class="uk-margin-large-left">
        <input type="radio" v-model="selectionValue" value="no" id="none" class="uk-radio"/>
        {{ __('landing.hardship_question_none') }}
      </label>
    </div>


    <div class="uk-width-1-1 uk-align-center uk-margin-large-top">
      <button :disabled="selectionValue === null" class="uk-button uk-button-secondary uk-button-large uk-width-small-1-1 uk-width-medium-1-3 uk-margin-bottom uk-align-center uk-animation-fade" @click="submit">
        <i class="uk-icon-square-o"></i> {{ __('landing.hardship_question_continue') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HardshipQuestion",
  props: ["program", 'question'],
  data() {
    return {
      selectionValue: null,
    };
  },
  mounted() {
    const focusableElements = (UIkit.Utils || UIkit.util).findFocusables(document.getElementById("pre-qual-questions"));

    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  },
  methods: {
    async submit() {
      let programAbbr = null;
      if(this.selectionValue == 'due' || this.selectionValue == 'due_benefits') {
        programAbbr = this.question.options.due;
      }else if (this.selectionValue == 'during') {
        programAbbr = this.question.options.during;
      }

      this.$emit('answer', {
        answer: this.selectionValue,
        programId: programAbbr,
      })

    }
  },
};
</script>
